<template>

    <rkm-modal
        :loading="loading"
        large
        ref="RkmModal"
        title="Histórico do núcleo familiar"
    >

        <rkm-row v-if="!loading && historico.length === 0">
            <rkm-col cols="12">
                Nenhum paciente saiu deste núcleo até o momento.
            </rkm-col>
        </rkm-row>

        <rkm-row v-else>
            <rkm-col cols="12">
                <rkm-table
                    :fields="fields"
                    :items="historico"
                    sort-by="dataSaida"
                    sort-desc
                >
                    <template v-slot:cell(dataEntrada)="row">
                        {{ row.value | formatDate }}
                    </template>

                    <template v-slot:cell(dataSaida)="row">
                        {{ row.value | formatDate }}
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer>
            <rkm-button @click="$refs.RkmModal.hide()">
                Fechar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

import { repository, error } from '@/mixins'
import format from '@/filters/formats'

export default {
    mixins: [ repository, error ],
    filters: {
        ...format,
    },
    data: () => ({
        loading: false,
        historico: [],
        fields: [
            {
                key: 'nome',
                label: 'Nome',
                sortable: true
            },
            {
                key: 'dataEntrada',
                label: 'Data de entrada',
                class: 'col-min text-center',
                sortable: true
            },
            {
                key: 'dataSaida',
                label: 'Data de saída',
                class: 'col-min text-center',
                sortable: true
            },
        ],
    }),
    created() {

        this.repositories = {
            paciente: this.getConectaSusRepository('cadastro.sujeitoAtencao.paciente'),
        }
    },
    methods: {
        open(nucleoFamiliarId) {

            this.loading = true
            this.historico = []

            this.repositories.paciente.getHistoricoNucleoFamiliar(nucleoFamiliarId)
                .then(({ data }) => this.historico = data)
                .catch(this.handleError)
                .finally(() => this.loading = false)

            this.$refs.RkmModal.show()
        },
    },
}
</script>
